import { render, staticRenderFns } from "./manage-transaction-type-modal.vue?vue&type=template&id=f79c4956"
import script from "./manage-transaction-type-modal.vue?vue&type=script&lang=js"
export * from "./manage-transaction-type-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports